import "../../../styles/global.css";
import React, { memo } from "react";
import DatePicker from "react-datepicker"

const CelesFloatingInputState = memo(
  ({
    disable = false,
    type = "text",
    backgroundColor = "#F3F4F6",
    className = "text-gray-800 opacity-100  ",
    label,
    value,
    error,
    border = "",
    shadow = "",
    onClick = null,
    name,
    setValue,
    onChange = () => {},
    ...rest
  }) => {

    const disableStyle = disable ? "text-coolGray-400 cursor-not-allowed" : "";

    return (
      <form
        className={"input-container rounded-lg " + border + " " + shadow}
        autoComplete={false}
      >
        <input
          onClick={onClick}
          disabled={disable}
          type={type}
          date
          className={
            "border rounded-lg border-coolGray-200  " + className + disableStyle
          }
          name={name}
          style={{ backgroundColor: backgroundColor }}
          value={value}
          onChange={onChange}
          {...rest}
        />
        <label
          className={
            ((value != undefined && value != "") || type == "date") && "filled"
          }
        >
          {label}
        </label>
        {error && (
          <div className="text-xs font-semibold text-red-600 ml-1">{error}</div>
        )}
      </form>
    );
  }
);

export default CelesFloatingInputState;
